import * as angular from "angular"
import "front-end-web-commons"

export default angular.module("r2BackgroundTaskJobModule", [
    "backgroundTaskJobModule"
]);